import { ReactNode, useEffect, useRef } from "react";
import ButtonIcon from "../button-icon";
import AccountSvg from "../icons/account";
import QuestionSvg from "../icons/question";
import styles from './style.module.css';
import classNames from "classnames";
import { useNavigate } from "react-router";
import { IUserDetails } from "../../context/types";

interface Props {
  children: ReactNode;
  user: IUserDetails | null;
  alert?: ReactNode;
  onHeightChange?: (height: number) => void;
}

const Modal = (props: Props) => {
  const navigate = useNavigate();
  const { children, alert, onHeightChange } = props;
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      modalRef.current?.classList.add(styles.open);
    }, 10);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    const node = modalRef.current;
    if (!node || !onHeightChange) return;

    const observer = new ResizeObserver(([entry]) => {
      if (entry) onHeightChange(entry.contentRect.height);
    });
    observer.observe(node);

    return () => observer.disconnect();
  }, [onHeightChange]);

  const onHandlerClickAccount = () => {
    navigate("account");
  }
  
  const onHandlerClickQuestion = () => {
    navigate("/faq");
  }

  return (
    <div ref={modalRef} className={styles.modalContainer}>
      {alert && <div className={styles.alertWrap}>{alert}</div>}
      <div className={classNames(styles.modal, styles.glassBorder)}>
        {children}
        <div className={styles.general}>
          <ButtonIcon icon={<AccountSvg/>} onClick={() => onHandlerClickAccount()}/>
          <ButtonIcon icon={<QuestionSvg/>} onClick={() => onHandlerClickQuestion()}/>
        </div>
      </div>
    </div>
  )
}

export default Modal;
